export const applyFilterChange = (filters, key, value) => {
  const updated = { ...filters };
  if (
    value === undefined ||
    value === null ||
    (Array.isArray(value) && !value.length)
  ) {
    delete updated[key];
  } else {
    updated[key] = value;
  }
  return updated;
};
